export default "__VITE_ASSET__BH4riJmb__"